/* nv-v4.js — 24/10/2026, version minimale (retour d'Ilyes : on ne change que l'offre).
   - titre « OFFERTA SPECIALE HALLOWEEN » + chrono juste au-dessus de la 1re offre MoonBundle
   - cadeaux à cadenas (vrais cadeaux MoonBundle : sacchetto + culotte avec 2+2)
   - barre orange animée + délai sous le bouton ; avis défilant sous les accordéons
   La taille reste gérée par le quiz et les menus d'origine (nv-moon.js bloque l'ajout sans taille).
   MoonBundle n'est jamais déplacé ; tout est dans try/catch : si ce script plante, la page d'origine reste intacte. */
(function () {
  if (window.__nv4) return; window.__nv4 = true;
  var C = window.NV_V4 || {};
  var setVal = Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, 'value').set;
  var SIZES = ['S', 'M', 'L', 'XL', '2XL', '3XL', '4XL'];
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function fire(s) { s.dispatchEvent(new Event('change', { bubbles: true })); s.dispatchEvent(new Event('input', { bubbles: true })); }
  function opts() { return $$('.moonbundle-option'); }
  function active() { return $('.moonbundle-option.moonbundle-option-active'); }
  function idx() { var a = active(); return a ? opts().indexOf(a) : -1; }
  function isSize(sel) { return [].some.call(sel.options, function (o) { return SIZES.indexOf((o.value || '').trim().toUpperCase()) >= 0; }); }
  function lines(a) { return a ? [].filter.call(a.querySelectorAll('select'), isSize).length : 0; }
  function colSels(a) { return a ? [].filter.call(a.querySelectorAll('select'), function (s) { return [].some.call(s.options, function (o) { return o.value === 'Nero'; }); }) : []; }
  function okOpt(s, v) { return [].some.call(s.options, function (o) { return o.value === v && !o.disabled && !/esaurito/i.test(o.textContent); }); }

  /* ---------- chrono : une seule date de fin (window.NV_END posé par la barre saisonnière) ---------- */
  function fmt(s) { var z = function (v) { return (v < 10 ? '0' : '') + v; }; return z(Math.floor(s / 3600)) + ':' + z(Math.floor(s % 3600 / 60)) + ':' + z(s % 60); }
  function tick() {
    if (document.hidden) return;
    try {
      var s = window.NV_LEFT ? window.NV_LEFT() : -1, on = s >= 0;
      $$('[data-nv4-urg]').forEach(function (e) { e.hidden = !on; });
      if (!on) return;
      var txt = fmt(s);
      $$('[data-nv4-t]').forEach(function (e) { if (e.textContent !== txt) { if (e.firstChild && e.firstChild.nodeType === 3) e.firstChild.nodeValue = txt; else e.textContent = txt; } });
      var f = $('.nv4-fill'); if (f) f.style.width = '92%';
    } catch (e) {}
  }

  function lockSvg() { return '<svg viewBox="0 0 24 24" fill="#6f7a86" aria-hidden="true"><path d="M17 9V7a5 5 0 0 0-10 0v2H5.5A1.5 1.5 0 0 0 4 10.5v10A1.5 1.5 0 0 0 5.5 22h13a1.5 1.5 0 0 0 1.5-1.5v-10A1.5 1.5 0 0 0 18.5 9H17zM9 7a3 3 0 0 1 6 0v2H9V7z"/></svg>'; }
  function build(mc) {
    var anchor = mc.closest('[data-mdr-offers-slot]') || mc, host = anchor.parentNode, I = C.img || {};
    /* titre + chrono : juste au-dessus de « Acquista 1 » (le titre MoonBundle est masqué en CSS) */
    host.insertBefore(el('div', 'nv4-top',
      '<div class="nv4-bt"><span class="nv4-title">' + (C.title || 'OFFERTA SPECIALE') + '</span></div>'), anchor);
    host.insertBefore(el('div', 'nv4-after',
      '<p class="nv4-bh">Bonus inclusi oggi!</p><div class="nv4-bon">' +
      '<div class="nv4-bx" data-k="0"><span class="nv4-lb">Offerto <s>5,99 €</s></span><div class="nv4-in"><img src="' + (I.ship || '') + '" alt="" loading="lazy"><div class="nv4-nm">Spedizione offerta</div></div><div class="nv4-lock">' + lockSvg() + 'Bloccato</div></div>' +
      '<div class="nv4-bx" data-k="1"><span class="nv4-lb">Offerto <s>39,99 €</s></span><div class="nv4-in"><img src="' + (I.bra || '') + '" alt="" loading="lazy"><div class="nv4-nm">Reggiseno offerto</div></div><div class="nv4-lock">' + lockSvg() + 'Bloccato</div></div>' +
      '<div class="nv4-bx" data-k="2"><span class="nv4-lb">Sorpresa!</span><div class="nv4-in"><img src="' + (I.combo || '') + '" alt="" loading="lazy"><div class="nv4-nm">Sacchetto + culotte offerti</div></div><div class="nv4-lock">' + lockSvg() + 'Bloccato</div></div>' +
      '</div>'), anchor.nextSibling);
    var atc = $('.mdr-form .mdr-atc');
    if (atc) {
      atc.parentNode.insertBefore(el('div', 'nv4-tail',
        '<div data-nv4-urg hidden><div class="nv4-bar"><div class="nv4-fill"><span class="nv4-pk"></span><span class="nv4-mn">🤶</span></div></div>' +
        '<div class="nv4-barl"><b>92% venduto</b><span>Ordina entro <span data-nv4-t>--</span></span></div></div>'), atc.nextSibling);
      var pay = atc.parentNode.querySelector('.mdr-pay'), ref = pay ? pay.nextSibling : null;
      var tpl = document.getElementById('nv4-pay-tpl'), payHtml = (!pay && tpl) ? '<div class="nv4-pay">' + tpl.innerHTML + '</div>' : '';
      atc.parentNode.insertBefore(el('div', 'nv4-gar2', payHtml), ref);
    }
    /* avis défilant (tempo bebysh), sous le dernier accordéon */
    var accs = $$('.mdr-product__info .mdr-acc'), P = C.proof || [];
    if (accs.length && P.length) {
      var last = accs[accs.length - 1];
      last.parentNode.insertBefore(el('div', 'nv4-pf', P.map(function (r) {
        return '<article><div class="nv4-ph"><img src="' + r.p + '" alt="" loading="lazy" width="52" height="52"></div><div><div class="nv4-tp"><b>★★★★★</b><span>Cliente</span></div><p>' + r.t + '</p><small>' + r.n + ' · acquirente verificata</small></div></article>';
      }).join('')), last.nextSibling);
    }
  }

  function bonus() {
    var i = Math.max(0, idx()), u = i + 1; /* 1 : livraison ; 1+1 : + reggiseno offerto ; 2+2 : + sacchetto e culotte (MoonBundle) */
    $$('.nv4-bx').forEach(function (b) {
      var k = +b.getAttribute('data-k'), lock = k >= u, was = b.classList.contains('lk');
      b.classList.toggle('lk', lock); if (was && !lock) { b.classList.remove('pop'); void b.offsetWidth; b.classList.add('pop'); }
    });
    var nd = $('[data-nv4-nudge]');
    if (nd) nd.textContent = i === 0 ? 'Scegli 1 + 1: il secondo reggiseno è in regalo' : i === 1 ? 'Scegli 2 + 2 per sbloccare il regalo sorpresa' : 'Hai sbloccato tutti i regali!';
  }
  function num(s) { var m = (s || '').replace(/\s/g, '').match(/(\d+)[.,](\d{2})/); return m ? parseFloat(m[1] + '.' + m[2]) : 0; }
  function cards() {
    var P = C.packs || [];
    opts().forEach(function (o, i) {
      var d = o.querySelector('.moonbundle-option-details'); if (!d) return;
      if (P[i] && !d.querySelector('.nv4-pack')) { var im = el('span', 'nv4-pack'); im.style.backgroundImage = 'url("' + P[i] + '")'; im.setAttribute('aria-hidden', 'true'); d.insertBefore(im, d.firstChild); } /* fond CSS : nv-moon.js réécrit les <img> de l'offre à chaque couleur */
      var sub = o.querySelector('.moonbundle-option-subtitle'), np = o.querySelector('.moonbundle-option-single-price'), op = o.querySelector('.moonbundle-option-old-price');
      if (i > 0 && sub && np && op && !o.querySelector('.nv4-save')) {
        var diff = num(op.textContent) - num(np.textContent);
        if (diff > 0.5) { var pill = el('div', 'nv4-save', 'RISPARMI ' + diff.toFixed(2).replace('.', ',') + ' €'); sub.parentNode.insertBefore(pill, sub); }
      }
    });
  }
  /* bouton juste sous les bonus (agencement bebysh). On ne DÉPLACE rien : le thème remet ses blocs au-dessus du bouton
     (essai du 24/10 : replacés en ~1 s). On pose une classe sur le conteneur et l'ordre d'affichage se fait en CSS (flex order). */
  function layout() { var btn = $('.mdr-form .mdr-atc'); if (btn && btn.parentNode && !btn.parentNode.classList.contains('nv4-buy')) btn.parentNode.classList.add('nv4-buy'); }
  /* Tiroir panier MoonBundle : bloc « photos clientes + 4,8/5 + citation + garanzia » au-dessus du bouton (comme bebysh).
     Le tiroir se reconstruit à chaque ouverture : on réinsère si besoin (observateur léger sur le body). */
  function cartProof() {
    try {
      var btn = $('.nv-cd-checkout'); if (!btn || (btn.previousElementSibling && btn.previousElementSibling.classList.contains('nv4-cp'))) return;
      var P = (C.proof || []).concat(C.proofMore || []), av = P.slice(0, 4).map(function (r, k) { return '<img src="' + r.p + '" width="22" height="22" alt="" style="margin-left:' + (k ? '-7px' : '0') + '">'; }).join('');
      var b = el('div', 'nv4-cp',
        '<div class="nv4-cp-top"><span class="nv4-cp-av">' + av + '</span><span class="nv4-cp-st">★★★★★</span><span class="nv4-cp-n">4,8/5</span></div>' +
        '<p class="nv4-cp-q">« ' + (C.cartQuote || '') + ' » — <strong>' + (C.cartQuoteName || '') + '</strong></p>' +
        '');   /* 03/11 (Ilyes) : ligne « Soddisfatta o rimborsata 90 giorni · Spedito in 24/48 ore » retiree du panier (doublon avec la garantie taille et la date de livraison) */
      btn.parentNode.insertBefore(b, btn);
    } catch (e) {}
  }
  var busy = false;
  function apply() {
    if (busy) return; busy = true;
    try { cards(); bonus(); layout(); } catch (e) {}
    busy = false;
  }

  var tries = 0;
  function boot() {
    var mc = $('nv-bundle'), o = opts();
    if (!mc || !o.length || !$('.mdr-form .mdr-atc')) { if (++tries < 80) setTimeout(boot, 250); return; }
    try {
      document.documentElement.classList.add('nv4-on');
      build(mc);
      var done = false; try { done = sessionStorage.getItem('nv4def') === '1'; } catch (e) {}
      if (!done && o[1] && idx() !== 1) { o[1].click(); try { sessionStorage.setItem('nv4def', '1'); } catch (e) {} }
      document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.moonbundle-option')) { setTimeout(apply, 150); setTimeout(apply, 600); } }, true);
      var tm; new MutationObserver(function () { clearTimeout(tm); tm = setTimeout(apply, 120); }).observe(mc, { childList: true, subtree: true });
      apply(); setTimeout(apply, 800);
      tick(); setInterval(tick, 1000);
      /* barre collante du bas : visible seulement après avoir DÉPASSÉ le vrai bouton (demande Ilyes 24/10) */
      var sticky = $('[data-mdr-sticky]');
      if (sticky) { var sb = $('.mdr-form .mdr-atc'); if (sb && 'IntersectionObserver' in window) { new IntersectionObserver(function (es) { var r = es[es.length - 1]; sticky.classList.toggle('nv4-past', !r.isIntersecting && r.boundingClientRect.top < 0); }, { threshold: 0 }).observe(sb); } else { var stick = function () { var b = $('.mdr-form .mdr-atc'); if (b) sticky.classList.toggle('nv4-past', b.getBoundingClientRect().bottom < 0); }; window.addEventListener('scroll', stick, { passive: true }); stick(); } }
      var tc, cdr = document.getElementById('CartDrawer'); new MutationObserver(function () { clearTimeout(tc); tc = setTimeout(cartProof, 150); }).observe(cdr || document.body, cdr ? { childList: true } : { childList: true, subtree: true }); cartProof();
      document.addEventListener('visibilitychange', tick); window.addEventListener('pageshow', function () { tick(); apply(); });
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* 28-10 origine immédiate des ventes : les UTM de la pub (campagne, pub) sont gardés au 1er et au dernier clic
   et copiés dans les attributs du panier → ils arrivent avec la commande, sans attendre le parcours client Shopify. */
(function () {
  try {
    var K = 'nv_utm', q = new URLSearchParams(location.search), s = {};
    try { s = JSON.parse(localStorage.getItem(K) || '{}') || {}; } catch (e) {}
    var now = { source: q.get('utm_source'), campaign: q.get('utm_campaign'), content: q.get('utm_content'), term: q.get('utm_term'), fbclid: q.get('fbclid') ? 1 : 0 };
    if (now.campaign || now.content || now.source) {
      now.t = new Date().toISOString().slice(0, 16);
      if (!s.first) s.first = now;
      s.last = now;
      try { localStorage.setItem(K, JSON.stringify(s)); } catch (e) {}
    }
    if (!s.last) return;
    var a = {
      nv_utm_source: s.last.source || '', nv_utm_campaign: s.last.campaign || '', nv_utm_content: s.last.content || '',
      nv_utm_term: s.last.term || '', nv_utm_t: s.last.t || '',
      nv_first_campaign: (s.first || {}).campaign || '', nv_first_content: (s.first || {}).content || '', nv_first_t: (s.first || {}).t || ''
    };
    /* 28-10 fix : à la 1re visite, Moonbundle crée son panier en même temps que nous et le sien gagne (nos UTM partaient
       dans un panier abandonné). On ne se fie plus à un envoi unique : on relit le vrai panier et on réécrit s'il manque. */
    var busy = 0;
    function sync() {
      if (busy) return; busy = 1;
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        var at = (c && c.attributes) || {};
        var miss = Object.keys(a).some(function (k) { return (at[k] || '') !== a[k]; });
        if (miss) return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: a }) });
      }).catch(function () {}).then(function () { busy = 0; });
    }
    [2500, 6000, 15000].forEach(function (d) { setTimeout(sync, d); });
    var t, f = window.fetch;
    window.fetch = function (u) {
      var p = f.apply(this, arguments);
      try { if (/\/cart\/(add|change|clear)/.test(String((u && u.url) || u))) p.then(function () { clearTimeout(t); t = setTimeout(sync, 800); }, function () {}); } catch (e) {}
      return p;
    };
    window.addEventListener('pageshow', function () { setTimeout(sync, 1500); });
  } catch (e) {}
})();
